import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 text-center">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-5xl md:text-7xl font-bold mb-6"
      >
        <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-purple-600 bg-clip-text text-transparent">
          YouTube Video Downloader
        </span>
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto"
      >
        Download videos, Reels, and clips from 4 major platforms instantly, safely, and in high quality.
      </motion.p>
    </div>
  );
};

export default HeroSection;
